import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";

const RowTeams = ({ index, data }) => {
  const { user } = useSelector((state) => state.authSlice);

  return (
    <tr>
      <td>{index}</td>
      <td>
        <figure className="avatar">
          {" "}
          <img src={data.image} alt={data.name} />{" "}
        </figure>
      </td>
      <td>{data.name}</td>
      <td>{data.description}</td>
      <td>
        {new Date(data.createdAt).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </td>
      <td>
        <div
          className={`badge ${
            data.status === "active" ? "badge-success" : "badge-danger"
          }`}
        >
          {data.status === "active" ? "Active" : "Banned"}
        </div>
      </td>
      <td>
        <NavLink to={`/members/${data._id}`} className="btn btn-primary">
          Detail
        </NavLink>
      </td>
      {user.type === "Admin" ? (
        <td>
          <div className="team-avatar-stack">
            {data.team && data.team.length > 0 ? (
              data.team.map((team, idx) => (
                <NavLink
                  key={idx}
                  to={`/team/${team._id}`}
                  className="team-avatar-item"
                  data-tooltip={team.name}
                  data-index={idx}
                  style={{ zIndex: data.team.length - idx }}
                >
                  <img
                    src={team.image}
                    className="avatar avatar-sm"
                    alt={team.name}
                  />
                </NavLink>
              ))
            ) : (
              <div
                className="team-avatar-item team-avatar-empty"
                data-tooltip="No Team"
              >
                <img
                  src="./assets/icons/team.png"
                  className="avatar avatar-sm"
                  alt="No Team"
                  data-tooltip="No Team"
                />
              </div>
            )}
          </div>
        </td>
      ) : (
        ""
      )}
      {user.type === "Admin" ? (
        <td>
          <NavLink to={`/employee/${data.id}`} className="btn btn-secondary">
            Detail
          </NavLink>
        </td>
      ) : (
        ""
      )}
    </tr>
  );
};

export default RowTeams;
